// src/context/ModalContext.js
import React, { createContext, useState, useContext } from "react";
import GlobalModal from "../../components/AModal";
const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [modalConfig, setModalConfig] = useState({
    open: false,
    title: "",
    content: null,
    actions: null,
    maxWidth: "sm",
    fullWidth: true,
  });

  const showModal = ({
    title,
    content,
    actions,
    maxWidth = "sm",
    fullWidth = true,
    closeCb = () => {},
  }) => {
    setModalConfig({
      open: true,
      title,
      content,
      actions,
      maxWidth,
      fullWidth,
      closeCb
    });
  };

  const hideModal = (isAvoidCallback = true) => {
    setModalConfig((prev) => {
      if (isAvoidCallback && prev.closeCb) prev.closeCb(); 
      return { ...prev, open: false };
    });
  
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal }}>
      {children}
      <GlobalModal {...modalConfig} onClose={hideModal} />
    </ModalContext.Provider>
  );
};
